@let project = this.project$() | async;

<cam-card [type]="'tertiary'" [fullHeight]="true">
  <cam-card-header>
    <cam-card-title>
      <div class="d-flex space-between align-center g-space-sm">
        <cam-title [level]="4" [isBold]="true">{{ 'project.project-profile.title' | translate }}</cam-title>
        @if (this.navigationLink()) {
          <cam-font-icon class="pointer" name="external-link-line" type="xs" (click)="this.navigate()"></cam-font-icon>
        }
      </div>
    </cam-card-title>
  </cam-card-header>
  <cam-card-content class="d-flex flex-column flex-fill g-space-sm">
    @if (this.editMode() && this.isEditing() && this.projectSelect) {
      <cam-input-choices [input]="this.projectSelect" [standalone]="true"></cam-input-choices>
    } @else {
      <cam-loader [isLoading]="this.requestState.isLoading()">
        <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
          @if (this.selectedId() && project) {
            <cam-project-profile
              class="d-flex flex-column flex-fill"
              [project]="project"
              [editable]="this.editMode()"
              (edit)="this.startEditing()"
            ></cam-project-profile>
          } @else if (this.editMode()) {
            <cam-button icon="plus" [type]="'secondary'" (action)="this.startEditing()">
              {{ 'project.project-profile.add-project' | translate }}
            </cam-button>
          } @else {
            <cam-empty [icon]="this.icon.Checked" [isEmpty]="true"></cam-empty>
          }
        </cam-error>
      </cam-loader>
    }
  </cam-card-content>
</cam-card>
